import { z } from "zod";

import { ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";

const DEFAULT = "";

const schema = z.union([
	// treat the blank string as undefined
	z
		.string()
		.trim()
		.pipe(z.literal(""))
		.transform(() => undefined),

	// convert the non-empty string to a number
	z.coerce.number(),
]);

type WidgetRange = ImpulseFormUnit<string, ReadonlyArray<string>, undefined | number>;

function max(kind: "GaugeChart"): number;
function max(kind: undefined | "GaugeChart"): undefined | number;
function max(kind: undefined | "GaugeChart"): undefined | number {
	return kind === "GaugeChart" ? 1 : undefined;
}

function init(initial = DEFAULT): WidgetRange {
	return ImpulseFormUnit(initial, {
		isInputDirty: isStringDirty,
		schema,
	});
}

const WidgetRange = {
	default: DEFAULT,
	max,
	init,
} as const;

export { WidgetRange };
